/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/root'
import { Route as indexRouteImport } from './routes/index'
import { Route as AppWrapperRouteImport } from './routes/AppWrapper'
import { Route as layoutAuthLayoutAuthLayoutRouteImport } from './routes/layout/auth-layout/AuthLayout'
import { Route as layoutAppLayoutAppLayoutRouteImport } from './routes/layout/app-layout/AppLayout'
import { Route as featuresWorkspacesPagesWorkspaceSelectionPageRouteImport } from './routes/features/workspaces/pages/WorkspaceSelectionPage'
import { Route as featuresAuthenticationPagesAuthGatewayPageRouteImport } from './routes/features/authentication/pages/AuthGatewayPage'
import { Route as featuresAuthenticationPagesCallbackPageRouteImport } from './routes/features/authentication/pages/CallbackPage'
import { Route as featuresAuthenticationPagesLogoutPageRouteImport } from './routes/features/authentication/pages/LogoutPage'
import { Route as featuresAuthenticationPagesOnboardingPageRouteImport } from './routes/features/authentication/pages/OnboardingPage'
import { Route as featuresInvitesPagesInviteAcceptancePageRouteImport } from './routes/features/invites/pages/InviteAcceptancePage'
import { Route as featuresOauthPagesOAuthConsentPageRouteImport } from './routes/features/oauth/pages/OAuthConsentPage'
import { Route as featuresOauthPagesOAuthLoginPageRouteImport } from './routes/features/oauth/pages/OAuthLoginPage'
import { Route as featuresDashboardPagesDashboardPageRouteImport } from './routes/features/dashboard/pages/DashboardPage'
import { Route as featuresSettingsAboutPagesAboutSettingsPageRouteImport } from './routes/features/settings/about/pages/AboutSettingsPage'
import { Route as featuresNotesPagesNotesRedirectPageRouteImport } from './routes/features/notes/pages/NotesRedirectPage'
import { Route as featuresNotificationsPagesNotificationListPageRouteImport } from './routes/features/notifications/pages/NotificationListPage'
import { Route as featuresProjectsPagesProjectLayoutRouteImport } from './routes/features/projects/pages/ProjectLayout'
import { Route as featuresSettingsProfilePagesProfileSettingsPageRouteImport } from './routes/features/settings/profile/pages/ProfileSettingsPage'
import { Route as featuresSettingsAiPagesAiSettingsPageRouteImport } from './routes/features/settings/ai/pages/AiSettingsPage'
import { Route as featuresAiPagesAiDevPageRouteImport } from './routes/features/ai/pages/AiDevPage'
import { Route as featuresSettingsCustomFieldsPagesCustomFieldSettingsPageRouteImport } from './routes/features/settings/custom-fields/pages/CustomFieldSettingsPage'
import { Route as featuresSettingsDatabasePagesDatabaseSettingsPageRouteImport } from './routes/features/settings/database/pages/DatabaseSettingsPage'
import { Route as featuresSettingsSubscriptionPagesDevSubscriptionTestingPageRouteImport } from './routes/features/settings/subscription/pages/DevSubscriptionTestingPage'
import { Route as featuresSettingsIntegrationsPagesIntegrationsSettingsPageRouteImport } from './routes/features/settings/integrations/pages/IntegrationsSettingsPage'
import { Route as featuresSettingsLabelsPagesLabelSettingsPageRouteImport } from './routes/features/settings/labels/pages/LabelSettingsPage'
import { Route as featuresSettingsMembersPagesMemberSettingsPageRouteImport } from './routes/features/settings/members/pages/MemberSettingsPage'
import { Route as featuresSettingsNotificationsPagesNotificationSettingsPageRouteImport } from './routes/features/settings/notifications/pages/NotificationSettingsPage'
import { Route as featuresSettingsPreferencesPagesPreferencesSettingsPageRouteImport } from './routes/features/settings/preferences/pages/PreferencesSettingsPage'
import { Route as featuresSettingsStatusPagesStatusSettingsPageRouteImport } from './routes/features/settings/status/pages/StatusSettingsPage'
import { Route as featuresSettingsSubscriptionPagesSubscriptionSettingsPageRouteImport } from './routes/features/settings/subscription/pages/SubscriptionSettingsPage'
import { Route as featuresSettingsTemplatesPagesTemplateManagementPageRouteImport } from './routes/features/settings/templates/pages/TemplateManagementPage'
import { Route as featuresSettingsWorkItemTypesPagesWorkItemTypeSettingsPageRouteImport } from './routes/features/settings/work-item-types/pages/WorkItemTypeSettingsPage'
import { Route as featuresSettingsWorkspacePagesWorkspaceSettingsPageRouteImport } from './routes/features/settings/workspace/pages/WorkspaceSettingsPage'
import { Route as featuresSpacesPagesSpaceDetailsPageRouteImport } from './routes/features/spaces/pages/SpaceDetailsPage'
import { Route as featuresTagsPagesTagListPageRouteImport } from './routes/features/tags/pages/TagListPage'
import { Route as featuresTagsPagesTagTasksPageRouteImport } from './routes/features/tags/pages/TagTasksPage'
import { Route as featuresTasksPagesTaskListPageRouteImport } from './routes/features/tasks/pages/TaskListPage'
import { Route as featuresTasksPagesTaskDetailsPageRouteImport } from './routes/features/tasks/pages/TaskDetailsPage'
import { Route as featuresTasksPagesSomedayPageRouteImport } from './routes/features/tasks/pages/SomedayPage'
import { Route as featuresTasksPagesTodayPageRouteImport } from './routes/features/tasks/pages/TodayPage'
import { Route as featuresTasksPagesUpcomingPageRouteImport } from './routes/features/tasks/pages/UpcomingPage'
import { Route as featuresNotesPagesDailyNotePageRouteImport } from './routes/features/notes/pages/DailyNotePage'
import { Route as featuresNotesPagesWeeklyNotePageRouteImport } from './routes/features/notes/pages/WeeklyNotePage'
import { Route as featuresProjectsPagesProjectSettingsPageRouteImport } from './routes/features/projects/pages/ProjectSettingsPage'
import { Route as featuresSpacesPagesSpaceBoardViewPageRouteImport } from './routes/features/spaces/pages/SpaceBoardViewPage'
import { Route as featuresSpacesPagesSpaceCalendarViewPageRouteImport } from './routes/features/spaces/pages/SpaceCalendarViewPage'
import { Route as featuresSpacesPagesSpaceGanttViewPageRouteImport } from './routes/features/spaces/pages/SpaceGanttViewPage'
import { Route as featuresSpacesPagesSpaceListViewPageRouteImport } from './routes/features/spaces/pages/SpaceListViewPage'
import { Route as featuresProjectsPagesCycleDetailsPageRouteImport } from './routes/features/projects/pages/CycleDetailsPage'
import { Route as featuresPagesPagesPageDetailsPageRouteImport } from './routes/features/pages/pages/PageDetailsPage'
import { Route as featuresProjectsPagesProjectViewsIndexPageRouteImport } from './routes/features/projects/pages/ProjectViewsIndexPage'
import { Route as featuresProjectsPagesProjectViewPageRouteImport } from './routes/features/projects/pages/ProjectViewPage'
import { Route as featuresSpacesPagesSpacePageDetailsPageRouteImport } from './routes/features/spaces/pages/SpacePageDetailsPage'
import { Route as featuresSpacesPagesSpaceProjectDetailsPageRouteImport } from './routes/features/spaces/pages/SpaceProjectDetailsPage'
import { Route as featuresSpacesPagesSpaceViewsIndexPageRouteImport } from './routes/features/spaces/pages/SpaceViewsIndexPage'
import { Route as featuresSpacesPagesSpaceViewPageRouteImport } from './routes/features/spaces/pages/SpaceViewPage'
import { Route as featuresSpacesPagesSpaceProjectSettingsPageRouteImport } from './routes/features/spaces/pages/SpaceProjectSettingsPage'
import { Route as featuresSpacesPagesSpaceCycleDetailsPageRouteImport } from './routes/features/spaces/pages/SpaceCycleDetailsPage'
import { Route as featuresSpacesPagesSpaceProjectPageDetailsPageRouteImport } from './routes/features/spaces/pages/SpaceProjectPageDetailsPage'
import { Route as featuresSpacesPagesSpaceProjectViewsIndexPageRouteImport } from './routes/features/spaces/pages/SpaceProjectViewsIndexPage'
import { Route as featuresSpacesPagesSpaceProjectViewPageRouteImport } from './routes/features/spaces/pages/SpaceProjectViewPage'

const indexRoute = indexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppWrapperRoute = AppWrapperRouteImport.update({
  id: '/_AppWrapper',
  getParentRoute: () => rootRouteImport,
} as any)
const layoutAuthLayoutAuthLayoutRoute =
  layoutAuthLayoutAuthLayoutRouteImport.update({
    id: '/_AuthLayout',
    getParentRoute: () => rootRouteImport,
  } as any)
const layoutAppLayoutAppLayoutRoute =
  layoutAppLayoutAppLayoutRouteImport.update({
    id: '/_AppLayout',
    getParentRoute: () => AppWrapperRoute,
  } as any)
const featuresWorkspacesPagesWorkspaceSelectionPageRoute =
  featuresWorkspacesPagesWorkspaceSelectionPageRouteImport.update({
    id: '/workspaces',
    path: '/workspaces',
    getParentRoute: () => AppWrapperRoute,
  } as any)
const featuresAuthenticationPagesAuthGatewayPageRoute =
  featuresAuthenticationPagesAuthGatewayPageRouteImport.update({
    id: '/auth',
    path: '/auth',
    getParentRoute: () => layoutAuthLayoutAuthLayoutRoute,
  } as any)
const featuresAuthenticationPagesCallbackPageRoute =
  featuresAuthenticationPagesCallbackPageRouteImport.update({
    id: '/callback',
    path: '/callback',
    getParentRoute: () => layoutAuthLayoutAuthLayoutRoute,
  } as any)
const featuresAuthenticationPagesLogoutPageRoute =
  featuresAuthenticationPagesLogoutPageRouteImport.update({
    id: '/logout',
    path: '/logout',
    getParentRoute: () => layoutAuthLayoutAuthLayoutRoute,
  } as any)
const featuresAuthenticationPagesOnboardingPageRoute =
  featuresAuthenticationPagesOnboardingPageRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => layoutAuthLayoutAuthLayoutRoute,
  } as any)
const featuresInvitesPagesInviteAcceptancePageRoute =
  featuresInvitesPagesInviteAcceptancePageRouteImport.update({
    id: '/invite/accept',
    path: '/invite/accept',
    getParentRoute: () => layoutAuthLayoutAuthLayoutRoute,
  } as any)
const featuresOauthPagesOAuthConsentPageRoute =
  featuresOauthPagesOAuthConsentPageRouteImport.update({
    id: '/oauth/consent',
    path: '/oauth/consent',
    getParentRoute: () => layoutAuthLayoutAuthLayoutRoute,
  } as any)
const featuresOauthPagesOAuthLoginPageRoute =
  featuresOauthPagesOAuthLoginPageRouteImport.update({
    id: '/oauth/login',
    path: '/oauth/login',
    getParentRoute: () => layoutAuthLayoutAuthLayoutRoute,
  } as any)
const featuresDashboardPagesDashboardPageRoute =
  featuresDashboardPagesDashboardPageRouteImport.update({
    id: '/$workspaceSlug/',
    path: '/$workspaceSlug/',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresSettingsAboutPagesAboutSettingsPageRoute =
  featuresSettingsAboutPagesAboutSettingsPageRouteImport.update({
    id: '/$workspaceSlug/_internal/build',
    path: '/$workspaceSlug/_internal/build',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresNotesPagesNotesRedirectPageRoute =
  featuresNotesPagesNotesRedirectPageRouteImport.update({
    id: '/$workspaceSlug/notes/',
    path: '/$workspaceSlug/notes/',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresNotificationsPagesNotificationListPageRoute =
  featuresNotificationsPagesNotificationListPageRouteImport.update({
    id: '/$workspaceSlug/notifications/',
    path: '/$workspaceSlug/notifications/',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresProjectsPagesProjectLayoutRoute =
  featuresProjectsPagesProjectLayoutRouteImport.update({
    id: '/$workspaceSlug/projects/$projectKey',
    path: '/$workspaceSlug/projects/$projectKey',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresSettingsProfilePagesProfileSettingsPageRoute =
  featuresSettingsProfilePagesProfileSettingsPageRouteImport.update({
    id: '/$workspaceSlug/settings/',
    path: '/$workspaceSlug/settings/',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresSettingsAiPagesAiSettingsPageRoute =
  featuresSettingsAiPagesAiSettingsPageRouteImport.update({
    id: '/$workspaceSlug/settings/ai',
    path: '/$workspaceSlug/settings/ai',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresAiPagesAiDevPageRoute =
  featuresAiPagesAiDevPageRouteImport.update({
    id: '/$workspaceSlug/settings/ai-dev',
    path: '/$workspaceSlug/settings/ai-dev',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresSettingsCustomFieldsPagesCustomFieldSettingsPageRoute =
  featuresSettingsCustomFieldsPagesCustomFieldSettingsPageRouteImport.update({
    id: '/$workspaceSlug/settings/custom-fields',
    path: '/$workspaceSlug/settings/custom-fields',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresSettingsDatabasePagesDatabaseSettingsPageRoute =
  featuresSettingsDatabasePagesDatabaseSettingsPageRouteImport.update({
    id: '/$workspaceSlug/settings/database',
    path: '/$workspaceSlug/settings/database',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresSettingsSubscriptionPagesDevSubscriptionTestingPageRoute =
  featuresSettingsSubscriptionPagesDevSubscriptionTestingPageRouteImport.update(
    {
      id: '/$workspaceSlug/settings/dev-subscription',
      path: '/$workspaceSlug/settings/dev-subscription',
      getParentRoute: () => layoutAppLayoutAppLayoutRoute,
    } as any,
  )
const featuresSettingsIntegrationsPagesIntegrationsSettingsPageRoute =
  featuresSettingsIntegrationsPagesIntegrationsSettingsPageRouteImport.update({
    id: '/$workspaceSlug/settings/integrations',
    path: '/$workspaceSlug/settings/integrations',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresSettingsLabelsPagesLabelSettingsPageRoute =
  featuresSettingsLabelsPagesLabelSettingsPageRouteImport.update({
    id: '/$workspaceSlug/settings/labels',
    path: '/$workspaceSlug/settings/labels',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresSettingsMembersPagesMemberSettingsPageRoute =
  featuresSettingsMembersPagesMemberSettingsPageRouteImport.update({
    id: '/$workspaceSlug/settings/members',
    path: '/$workspaceSlug/settings/members',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresSettingsNotificationsPagesNotificationSettingsPageRoute =
  featuresSettingsNotificationsPagesNotificationSettingsPageRouteImport.update({
    id: '/$workspaceSlug/settings/notifications',
    path: '/$workspaceSlug/settings/notifications',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresSettingsPreferencesPagesPreferencesSettingsPageRoute =
  featuresSettingsPreferencesPagesPreferencesSettingsPageRouteImport.update({
    id: '/$workspaceSlug/settings/preferences',
    path: '/$workspaceSlug/settings/preferences',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresSettingsStatusPagesStatusSettingsPageRoute =
  featuresSettingsStatusPagesStatusSettingsPageRouteImport.update({
    id: '/$workspaceSlug/settings/statuses',
    path: '/$workspaceSlug/settings/statuses',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresSettingsSubscriptionPagesSubscriptionSettingsPageRoute =
  featuresSettingsSubscriptionPagesSubscriptionSettingsPageRouteImport.update({
    id: '/$workspaceSlug/settings/subscription',
    path: '/$workspaceSlug/settings/subscription',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresSettingsTemplatesPagesTemplateManagementPageRoute =
  featuresSettingsTemplatesPagesTemplateManagementPageRouteImport.update({
    id: '/$workspaceSlug/settings/templates',
    path: '/$workspaceSlug/settings/templates',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresSettingsWorkItemTypesPagesWorkItemTypeSettingsPageRoute =
  featuresSettingsWorkItemTypesPagesWorkItemTypeSettingsPageRouteImport.update({
    id: '/$workspaceSlug/settings/work-item-types',
    path: '/$workspaceSlug/settings/work-item-types',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresSettingsWorkspacePagesWorkspaceSettingsPageRoute =
  featuresSettingsWorkspacePagesWorkspaceSettingsPageRouteImport.update({
    id: '/$workspaceSlug/settings/workspace',
    path: '/$workspaceSlug/settings/workspace',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresSpacesPagesSpaceDetailsPageRoute =
  featuresSpacesPagesSpaceDetailsPageRouteImport.update({
    id: '/$workspaceSlug/spaces/$spaceKey',
    path: '/$workspaceSlug/spaces/$spaceKey',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresTagsPagesTagListPageRoute =
  featuresTagsPagesTagListPageRouteImport.update({
    id: '/$workspaceSlug/tags/',
    path: '/$workspaceSlug/tags/',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresTagsPagesTagTasksPageRoute =
  featuresTagsPagesTagTasksPageRouteImport.update({
    id: '/$workspaceSlug/tags/$tagId',
    path: '/$workspaceSlug/tags/$tagId',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresTasksPagesTaskListPageRoute =
  featuresTasksPagesTaskListPageRouteImport.update({
    id: '/$workspaceSlug/tasks/',
    path: '/$workspaceSlug/tasks/',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresTasksPagesTaskDetailsPageRoute =
  featuresTasksPagesTaskDetailsPageRouteImport.update({
    id: '/$workspaceSlug/tasks/$taskId',
    path: '/$workspaceSlug/tasks/$taskId',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresTasksPagesSomedayPageRoute =
  featuresTasksPagesSomedayPageRouteImport.update({
    id: '/$workspaceSlug/tasks/someday',
    path: '/$workspaceSlug/tasks/someday',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresTasksPagesTodayPageRoute =
  featuresTasksPagesTodayPageRouteImport.update({
    id: '/$workspaceSlug/tasks/today',
    path: '/$workspaceSlug/tasks/today',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresTasksPagesUpcomingPageRoute =
  featuresTasksPagesUpcomingPageRouteImport.update({
    id: '/$workspaceSlug/tasks/upcoming',
    path: '/$workspaceSlug/tasks/upcoming',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresNotesPagesDailyNotePageRoute =
  featuresNotesPagesDailyNotePageRouteImport.update({
    id: '/$workspaceSlug/notes/daily/$noteDate',
    path: '/$workspaceSlug/notes/daily/$noteDate',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresNotesPagesWeeklyNotePageRoute =
  featuresNotesPagesWeeklyNotePageRouteImport.update({
    id: '/$workspaceSlug/notes/weekly/$noteDate',
    path: '/$workspaceSlug/notes/weekly/$noteDate',
    getParentRoute: () => layoutAppLayoutAppLayoutRoute,
  } as any)
const featuresProjectsPagesProjectSettingsPageRoute =
  featuresProjectsPagesProjectSettingsPageRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => featuresProjectsPagesProjectLayoutRoute,
  } as any)
const featuresSpacesPagesSpaceBoardViewPageRoute =
  featuresSpacesPagesSpaceBoardViewPageRouteImport.update({
    id: '/board',
    path: '/board',
    getParentRoute: () => featuresSpacesPagesSpaceDetailsPageRoute,
  } as any)
const featuresSpacesPagesSpaceCalendarViewPageRoute =
  featuresSpacesPagesSpaceCalendarViewPageRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => featuresSpacesPagesSpaceDetailsPageRoute,
  } as any)
const featuresSpacesPagesSpaceGanttViewPageRoute =
  featuresSpacesPagesSpaceGanttViewPageRouteImport.update({
    id: '/gantt',
    path: '/gantt',
    getParentRoute: () => featuresSpacesPagesSpaceDetailsPageRoute,
  } as any)
const featuresSpacesPagesSpaceListViewPageRoute =
  featuresSpacesPagesSpaceListViewPageRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => featuresSpacesPagesSpaceDetailsPageRoute,
  } as any)
const featuresProjectsPagesCycleDetailsPageRoute =
  featuresProjectsPagesCycleDetailsPageRouteImport.update({
    id: '/cycles/$cycleId',
    path: '/cycles/$cycleId',
    getParentRoute: () => featuresProjectsPagesProjectLayoutRoute,
  } as any)
const featuresPagesPagesPageDetailsPageRoute =
  featuresPagesPagesPageDetailsPageRouteImport.update({
    id: '/pages/$pageSlug',
    path: '/pages/$pageSlug',
    getParentRoute: () => featuresProjectsPagesProjectLayoutRoute,
  } as any)
const featuresProjectsPagesProjectViewsIndexPageRoute =
  featuresProjectsPagesProjectViewsIndexPageRouteImport.update({
    id: '/views/',
    path: '/views/',
    getParentRoute: () => featuresProjectsPagesProjectLayoutRoute,
  } as any)
const featuresProjectsPagesProjectViewPageRoute =
  featuresProjectsPagesProjectViewPageRouteImport.update({
    id: '/views/$viewId',
    path: '/views/$viewId',
    getParentRoute: () => featuresProjectsPagesProjectLayoutRoute,
  } as any)
const featuresSpacesPagesSpacePageDetailsPageRoute =
  featuresSpacesPagesSpacePageDetailsPageRouteImport.update({
    id: '/pages/$pageSlug',
    path: '/pages/$pageSlug',
    getParentRoute: () => featuresSpacesPagesSpaceDetailsPageRoute,
  } as any)
const featuresSpacesPagesSpaceProjectDetailsPageRoute =
  featuresSpacesPagesSpaceProjectDetailsPageRouteImport.update({
    id: '/projects/$projectKey',
    path: '/projects/$projectKey',
    getParentRoute: () => featuresSpacesPagesSpaceDetailsPageRoute,
  } as any)
const featuresSpacesPagesSpaceViewsIndexPageRoute =
  featuresSpacesPagesSpaceViewsIndexPageRouteImport.update({
    id: '/views/',
    path: '/views/',
    getParentRoute: () => featuresSpacesPagesSpaceDetailsPageRoute,
  } as any)
const featuresSpacesPagesSpaceViewPageRoute =
  featuresSpacesPagesSpaceViewPageRouteImport.update({
    id: '/views/$viewId',
    path: '/views/$viewId',
    getParentRoute: () => featuresSpacesPagesSpaceDetailsPageRoute,
  } as any)
const featuresSpacesPagesSpaceProjectSettingsPageRoute =
  featuresSpacesPagesSpaceProjectSettingsPageRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => featuresSpacesPagesSpaceProjectDetailsPageRoute,
  } as any)
const featuresSpacesPagesSpaceCycleDetailsPageRoute =
  featuresSpacesPagesSpaceCycleDetailsPageRouteImport.update({
    id: '/cycles/$cycleId',
    path: '/cycles/$cycleId',
    getParentRoute: () => featuresSpacesPagesSpaceProjectDetailsPageRoute,
  } as any)
const featuresSpacesPagesSpaceProjectPageDetailsPageRoute =
  featuresSpacesPagesSpaceProjectPageDetailsPageRouteImport.update({
    id: '/pages/$pageSlug',
    path: '/pages/$pageSlug',
    getParentRoute: () => featuresSpacesPagesSpaceProjectDetailsPageRoute,
  } as any)
const featuresSpacesPagesSpaceProjectViewsIndexPageRoute =
  featuresSpacesPagesSpaceProjectViewsIndexPageRouteImport.update({
    id: '/views/',
    path: '/views/',
    getParentRoute: () => featuresSpacesPagesSpaceProjectDetailsPageRoute,
  } as any)
const featuresSpacesPagesSpaceProjectViewPageRoute =
  featuresSpacesPagesSpaceProjectViewPageRouteImport.update({
    id: '/views/$viewId',
    path: '/views/$viewId',
    getParentRoute: () => featuresSpacesPagesSpaceProjectDetailsPageRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof indexRoute
  '/workspaces': typeof featuresWorkspacesPagesWorkspaceSelectionPageRoute
  '/auth': typeof featuresAuthenticationPagesAuthGatewayPageRoute
  '/callback': typeof featuresAuthenticationPagesCallbackPageRoute
  '/logout': typeof featuresAuthenticationPagesLogoutPageRoute
  '/onboarding': typeof featuresAuthenticationPagesOnboardingPageRoute
  '/invite/accept': typeof featuresInvitesPagesInviteAcceptancePageRoute
  '/oauth/consent': typeof featuresOauthPagesOAuthConsentPageRoute
  '/oauth/login': typeof featuresOauthPagesOAuthLoginPageRoute
  '/$workspaceSlug/': typeof featuresDashboardPagesDashboardPageRoute
  '/$workspaceSlug/notes/': typeof featuresNotesPagesNotesRedirectPageRoute
  '/$workspaceSlug/notifications/': typeof featuresNotificationsPagesNotificationListPageRoute
  '/$workspaceSlug/settings/': typeof featuresSettingsProfilePagesProfileSettingsPageRoute
  '/$workspaceSlug/tags/': typeof featuresTagsPagesTagListPageRoute
  '/$workspaceSlug/tasks/': typeof featuresTasksPagesTaskListPageRoute
  '/$workspaceSlug/_internal/build': typeof featuresSettingsAboutPagesAboutSettingsPageRoute
  '/$workspaceSlug/projects/$projectKey': typeof featuresProjectsPagesProjectLayoutRouteWithChildren
  '/$workspaceSlug/settings/ai': typeof featuresSettingsAiPagesAiSettingsPageRoute
  '/$workspaceSlug/settings/ai-dev': typeof featuresAiPagesAiDevPageRoute
  '/$workspaceSlug/settings/custom-fields': typeof featuresSettingsCustomFieldsPagesCustomFieldSettingsPageRoute
  '/$workspaceSlug/settings/database': typeof featuresSettingsDatabasePagesDatabaseSettingsPageRoute
  '/$workspaceSlug/settings/dev-subscription': typeof featuresSettingsSubscriptionPagesDevSubscriptionTestingPageRoute
  '/$workspaceSlug/settings/integrations': typeof featuresSettingsIntegrationsPagesIntegrationsSettingsPageRoute
  '/$workspaceSlug/settings/labels': typeof featuresSettingsLabelsPagesLabelSettingsPageRoute
  '/$workspaceSlug/settings/members': typeof featuresSettingsMembersPagesMemberSettingsPageRoute
  '/$workspaceSlug/settings/notifications': typeof featuresSettingsNotificationsPagesNotificationSettingsPageRoute
  '/$workspaceSlug/settings/preferences': typeof featuresSettingsPreferencesPagesPreferencesSettingsPageRoute
  '/$workspaceSlug/settings/statuses': typeof featuresSettingsStatusPagesStatusSettingsPageRoute
  '/$workspaceSlug/settings/subscription': typeof featuresSettingsSubscriptionPagesSubscriptionSettingsPageRoute
  '/$workspaceSlug/settings/templates': typeof featuresSettingsTemplatesPagesTemplateManagementPageRoute
  '/$workspaceSlug/settings/work-item-types': typeof featuresSettingsWorkItemTypesPagesWorkItemTypeSettingsPageRoute
  '/$workspaceSlug/settings/workspace': typeof featuresSettingsWorkspacePagesWorkspaceSettingsPageRoute
  '/$workspaceSlug/spaces/$spaceKey': typeof featuresSpacesPagesSpaceDetailsPageRouteWithChildren
  '/$workspaceSlug/tags/$tagId': typeof featuresTagsPagesTagTasksPageRoute
  '/$workspaceSlug/tasks/$taskId': typeof featuresTasksPagesTaskDetailsPageRoute
  '/$workspaceSlug/tasks/someday': typeof featuresTasksPagesSomedayPageRoute
  '/$workspaceSlug/tasks/today': typeof featuresTasksPagesTodayPageRoute
  '/$workspaceSlug/tasks/upcoming': typeof featuresTasksPagesUpcomingPageRoute
  '/$workspaceSlug/notes/daily/$noteDate': typeof featuresNotesPagesDailyNotePageRoute
  '/$workspaceSlug/notes/weekly/$noteDate': typeof featuresNotesPagesWeeklyNotePageRoute
  '/$workspaceSlug/projects/$projectKey/settings': typeof featuresProjectsPagesProjectSettingsPageRoute
  '/$workspaceSlug/spaces/$spaceKey/board': typeof featuresSpacesPagesSpaceBoardViewPageRoute
  '/$workspaceSlug/spaces/$spaceKey/calendar': typeof featuresSpacesPagesSpaceCalendarViewPageRoute
  '/$workspaceSlug/spaces/$spaceKey/gantt': typeof featuresSpacesPagesSpaceGanttViewPageRoute
  '/$workspaceSlug/spaces/$spaceKey/list': typeof featuresSpacesPagesSpaceListViewPageRoute
  '/$workspaceSlug/projects/$projectKey/views/': typeof featuresProjectsPagesProjectViewsIndexPageRoute
  '/$workspaceSlug/spaces/$spaceKey/views/': typeof featuresSpacesPagesSpaceViewsIndexPageRoute
  '/$workspaceSlug/projects/$projectKey/cycles/$cycleId': typeof featuresProjectsPagesCycleDetailsPageRoute
  '/$workspaceSlug/projects/$projectKey/pages/$pageSlug': typeof featuresPagesPagesPageDetailsPageRoute
  '/$workspaceSlug/projects/$projectKey/views/$viewId': typeof featuresProjectsPagesProjectViewPageRoute
  '/$workspaceSlug/spaces/$spaceKey/pages/$pageSlug': typeof featuresSpacesPagesSpacePageDetailsPageRoute
  '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey': typeof featuresSpacesPagesSpaceProjectDetailsPageRouteWithChildren
  '/$workspaceSlug/spaces/$spaceKey/views/$viewId': typeof featuresSpacesPagesSpaceViewPageRoute
  '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/settings': typeof featuresSpacesPagesSpaceProjectSettingsPageRoute
  '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/views/': typeof featuresSpacesPagesSpaceProjectViewsIndexPageRoute
  '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/cycles/$cycleId': typeof featuresSpacesPagesSpaceCycleDetailsPageRoute
  '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/pages/$pageSlug': typeof featuresSpacesPagesSpaceProjectPageDetailsPageRoute
  '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/views/$viewId': typeof featuresSpacesPagesSpaceProjectViewPageRoute
}
export interface FileRoutesByTo {
  '/': typeof indexRoute
  '/workspaces': typeof featuresWorkspacesPagesWorkspaceSelectionPageRoute
  '/auth': typeof featuresAuthenticationPagesAuthGatewayPageRoute
  '/callback': typeof featuresAuthenticationPagesCallbackPageRoute
  '/logout': typeof featuresAuthenticationPagesLogoutPageRoute
  '/onboarding': typeof featuresAuthenticationPagesOnboardingPageRoute
  '/invite/accept': typeof featuresInvitesPagesInviteAcceptancePageRoute
  '/oauth/consent': typeof featuresOauthPagesOAuthConsentPageRoute
  '/oauth/login': typeof featuresOauthPagesOAuthLoginPageRoute
  '/$workspaceSlug': typeof featuresDashboardPagesDashboardPageRoute
  '/$workspaceSlug/notes': typeof featuresNotesPagesNotesRedirectPageRoute
  '/$workspaceSlug/notifications': typeof featuresNotificationsPagesNotificationListPageRoute
  '/$workspaceSlug/settings': typeof featuresSettingsProfilePagesProfileSettingsPageRoute
  '/$workspaceSlug/tags': typeof featuresTagsPagesTagListPageRoute
  '/$workspaceSlug/tasks': typeof featuresTasksPagesTaskListPageRoute
  '/$workspaceSlug/_internal/build': typeof featuresSettingsAboutPagesAboutSettingsPageRoute
  '/$workspaceSlug/projects/$projectKey': typeof featuresProjectsPagesProjectLayoutRouteWithChildren
  '/$workspaceSlug/settings/ai': typeof featuresSettingsAiPagesAiSettingsPageRoute
  '/$workspaceSlug/settings/ai-dev': typeof featuresAiPagesAiDevPageRoute
  '/$workspaceSlug/settings/custom-fields': typeof featuresSettingsCustomFieldsPagesCustomFieldSettingsPageRoute
  '/$workspaceSlug/settings/database': typeof featuresSettingsDatabasePagesDatabaseSettingsPageRoute
  '/$workspaceSlug/settings/dev-subscription': typeof featuresSettingsSubscriptionPagesDevSubscriptionTestingPageRoute
  '/$workspaceSlug/settings/integrations': typeof featuresSettingsIntegrationsPagesIntegrationsSettingsPageRoute
  '/$workspaceSlug/settings/labels': typeof featuresSettingsLabelsPagesLabelSettingsPageRoute
  '/$workspaceSlug/settings/members': typeof featuresSettingsMembersPagesMemberSettingsPageRoute
  '/$workspaceSlug/settings/notifications': typeof featuresSettingsNotificationsPagesNotificationSettingsPageRoute
  '/$workspaceSlug/settings/preferences': typeof featuresSettingsPreferencesPagesPreferencesSettingsPageRoute
  '/$workspaceSlug/settings/statuses': typeof featuresSettingsStatusPagesStatusSettingsPageRoute
  '/$workspaceSlug/settings/subscription': typeof featuresSettingsSubscriptionPagesSubscriptionSettingsPageRoute
  '/$workspaceSlug/settings/templates': typeof featuresSettingsTemplatesPagesTemplateManagementPageRoute
  '/$workspaceSlug/settings/work-item-types': typeof featuresSettingsWorkItemTypesPagesWorkItemTypeSettingsPageRoute
  '/$workspaceSlug/settings/workspace': typeof featuresSettingsWorkspacePagesWorkspaceSettingsPageRoute
  '/$workspaceSlug/spaces/$spaceKey': typeof featuresSpacesPagesSpaceDetailsPageRouteWithChildren
  '/$workspaceSlug/tags/$tagId': typeof featuresTagsPagesTagTasksPageRoute
  '/$workspaceSlug/tasks/$taskId': typeof featuresTasksPagesTaskDetailsPageRoute
  '/$workspaceSlug/tasks/someday': typeof featuresTasksPagesSomedayPageRoute
  '/$workspaceSlug/tasks/today': typeof featuresTasksPagesTodayPageRoute
  '/$workspaceSlug/tasks/upcoming': typeof featuresTasksPagesUpcomingPageRoute
  '/$workspaceSlug/notes/daily/$noteDate': typeof featuresNotesPagesDailyNotePageRoute
  '/$workspaceSlug/notes/weekly/$noteDate': typeof featuresNotesPagesWeeklyNotePageRoute
  '/$workspaceSlug/projects/$projectKey/settings': typeof featuresProjectsPagesProjectSettingsPageRoute
  '/$workspaceSlug/spaces/$spaceKey/board': typeof featuresSpacesPagesSpaceBoardViewPageRoute
  '/$workspaceSlug/spaces/$spaceKey/calendar': typeof featuresSpacesPagesSpaceCalendarViewPageRoute
  '/$workspaceSlug/spaces/$spaceKey/gantt': typeof featuresSpacesPagesSpaceGanttViewPageRoute
  '/$workspaceSlug/spaces/$spaceKey/list': typeof featuresSpacesPagesSpaceListViewPageRoute
  '/$workspaceSlug/projects/$projectKey/views': typeof featuresProjectsPagesProjectViewsIndexPageRoute
  '/$workspaceSlug/spaces/$spaceKey/views': typeof featuresSpacesPagesSpaceViewsIndexPageRoute
  '/$workspaceSlug/projects/$projectKey/cycles/$cycleId': typeof featuresProjectsPagesCycleDetailsPageRoute
  '/$workspaceSlug/projects/$projectKey/pages/$pageSlug': typeof featuresPagesPagesPageDetailsPageRoute
  '/$workspaceSlug/projects/$projectKey/views/$viewId': typeof featuresProjectsPagesProjectViewPageRoute
  '/$workspaceSlug/spaces/$spaceKey/pages/$pageSlug': typeof featuresSpacesPagesSpacePageDetailsPageRoute
  '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey': typeof featuresSpacesPagesSpaceProjectDetailsPageRouteWithChildren
  '/$workspaceSlug/spaces/$spaceKey/views/$viewId': typeof featuresSpacesPagesSpaceViewPageRoute
  '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/settings': typeof featuresSpacesPagesSpaceProjectSettingsPageRoute
  '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/views': typeof featuresSpacesPagesSpaceProjectViewsIndexPageRoute
  '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/cycles/$cycleId': typeof featuresSpacesPagesSpaceCycleDetailsPageRoute
  '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/pages/$pageSlug': typeof featuresSpacesPagesSpaceProjectPageDetailsPageRoute
  '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/views/$viewId': typeof featuresSpacesPagesSpaceProjectViewPageRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof indexRoute
  '/_AppWrapper': typeof AppWrapperRouteWithChildren
  '/_AuthLayout': typeof layoutAuthLayoutAuthLayoutRouteWithChildren
  '/_AppWrapper/_AppLayout': typeof layoutAppLayoutAppLayoutRouteWithChildren
  '/_AppWrapper/workspaces': typeof featuresWorkspacesPagesWorkspaceSelectionPageRoute
  '/_AuthLayout/auth': typeof featuresAuthenticationPagesAuthGatewayPageRoute
  '/_AuthLayout/callback': typeof featuresAuthenticationPagesCallbackPageRoute
  '/_AuthLayout/logout': typeof featuresAuthenticationPagesLogoutPageRoute
  '/_AuthLayout/onboarding': typeof featuresAuthenticationPagesOnboardingPageRoute
  '/_AuthLayout/invite/accept': typeof featuresInvitesPagesInviteAcceptancePageRoute
  '/_AuthLayout/oauth/consent': typeof featuresOauthPagesOAuthConsentPageRoute
  '/_AuthLayout/oauth/login': typeof featuresOauthPagesOAuthLoginPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/': typeof featuresDashboardPagesDashboardPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/notes/': typeof featuresNotesPagesNotesRedirectPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/notifications/': typeof featuresNotificationsPagesNotificationListPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/settings/': typeof featuresSettingsProfilePagesProfileSettingsPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/tags/': typeof featuresTagsPagesTagListPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/tasks/': typeof featuresTasksPagesTaskListPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/_internal/build': typeof featuresSettingsAboutPagesAboutSettingsPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/projects/$projectKey': typeof featuresProjectsPagesProjectLayoutRouteWithChildren
  '/_AppWrapper/_AppLayout/$workspaceSlug/settings/ai': typeof featuresSettingsAiPagesAiSettingsPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/settings/ai-dev': typeof featuresAiPagesAiDevPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/settings/custom-fields': typeof featuresSettingsCustomFieldsPagesCustomFieldSettingsPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/settings/database': typeof featuresSettingsDatabasePagesDatabaseSettingsPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/settings/dev-subscription': typeof featuresSettingsSubscriptionPagesDevSubscriptionTestingPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/settings/integrations': typeof featuresSettingsIntegrationsPagesIntegrationsSettingsPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/settings/labels': typeof featuresSettingsLabelsPagesLabelSettingsPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/settings/members': typeof featuresSettingsMembersPagesMemberSettingsPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/settings/notifications': typeof featuresSettingsNotificationsPagesNotificationSettingsPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/settings/preferences': typeof featuresSettingsPreferencesPagesPreferencesSettingsPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/settings/statuses': typeof featuresSettingsStatusPagesStatusSettingsPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/settings/subscription': typeof featuresSettingsSubscriptionPagesSubscriptionSettingsPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/settings/templates': typeof featuresSettingsTemplatesPagesTemplateManagementPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/settings/work-item-types': typeof featuresSettingsWorkItemTypesPagesWorkItemTypeSettingsPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/settings/workspace': typeof featuresSettingsWorkspacePagesWorkspaceSettingsPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey': typeof featuresSpacesPagesSpaceDetailsPageRouteWithChildren
  '/_AppWrapper/_AppLayout/$workspaceSlug/tags/$tagId': typeof featuresTagsPagesTagTasksPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/tasks/$taskId': typeof featuresTasksPagesTaskDetailsPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/tasks/someday': typeof featuresTasksPagesSomedayPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/tasks/today': typeof featuresTasksPagesTodayPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/tasks/upcoming': typeof featuresTasksPagesUpcomingPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/notes/daily/$noteDate': typeof featuresNotesPagesDailyNotePageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/notes/weekly/$noteDate': typeof featuresNotesPagesWeeklyNotePageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/projects/$projectKey/settings': typeof featuresProjectsPagesProjectSettingsPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/board': typeof featuresSpacesPagesSpaceBoardViewPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/calendar': typeof featuresSpacesPagesSpaceCalendarViewPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/gantt': typeof featuresSpacesPagesSpaceGanttViewPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/list': typeof featuresSpacesPagesSpaceListViewPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/projects/$projectKey/views/': typeof featuresProjectsPagesProjectViewsIndexPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/views/': typeof featuresSpacesPagesSpaceViewsIndexPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/projects/$projectKey/cycles/$cycleId': typeof featuresProjectsPagesCycleDetailsPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/projects/$projectKey/pages/$pageSlug': typeof featuresPagesPagesPageDetailsPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/projects/$projectKey/views/$viewId': typeof featuresProjectsPagesProjectViewPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/pages/$pageSlug': typeof featuresSpacesPagesSpacePageDetailsPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/projects/$projectKey': typeof featuresSpacesPagesSpaceProjectDetailsPageRouteWithChildren
  '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/views/$viewId': typeof featuresSpacesPagesSpaceViewPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/settings': typeof featuresSpacesPagesSpaceProjectSettingsPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/views/': typeof featuresSpacesPagesSpaceProjectViewsIndexPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/cycles/$cycleId': typeof featuresSpacesPagesSpaceCycleDetailsPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/pages/$pageSlug': typeof featuresSpacesPagesSpaceProjectPageDetailsPageRoute
  '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/views/$viewId': typeof featuresSpacesPagesSpaceProjectViewPageRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/workspaces'
    | '/auth'
    | '/callback'
    | '/logout'
    | '/onboarding'
    | '/invite/accept'
    | '/oauth/consent'
    | '/oauth/login'
    | '/$workspaceSlug/'
    | '/$workspaceSlug/notes/'
    | '/$workspaceSlug/notifications/'
    | '/$workspaceSlug/settings/'
    | '/$workspaceSlug/tags/'
    | '/$workspaceSlug/tasks/'
    | '/$workspaceSlug/_internal/build'
    | '/$workspaceSlug/projects/$projectKey'
    | '/$workspaceSlug/settings/ai'
    | '/$workspaceSlug/settings/ai-dev'
    | '/$workspaceSlug/settings/custom-fields'
    | '/$workspaceSlug/settings/database'
    | '/$workspaceSlug/settings/dev-subscription'
    | '/$workspaceSlug/settings/integrations'
    | '/$workspaceSlug/settings/labels'
    | '/$workspaceSlug/settings/members'
    | '/$workspaceSlug/settings/notifications'
    | '/$workspaceSlug/settings/preferences'
    | '/$workspaceSlug/settings/statuses'
    | '/$workspaceSlug/settings/subscription'
    | '/$workspaceSlug/settings/templates'
    | '/$workspaceSlug/settings/work-item-types'
    | '/$workspaceSlug/settings/workspace'
    | '/$workspaceSlug/spaces/$spaceKey'
    | '/$workspaceSlug/tags/$tagId'
    | '/$workspaceSlug/tasks/$taskId'
    | '/$workspaceSlug/tasks/someday'
    | '/$workspaceSlug/tasks/today'
    | '/$workspaceSlug/tasks/upcoming'
    | '/$workspaceSlug/notes/daily/$noteDate'
    | '/$workspaceSlug/notes/weekly/$noteDate'
    | '/$workspaceSlug/projects/$projectKey/settings'
    | '/$workspaceSlug/spaces/$spaceKey/board'
    | '/$workspaceSlug/spaces/$spaceKey/calendar'
    | '/$workspaceSlug/spaces/$spaceKey/gantt'
    | '/$workspaceSlug/spaces/$spaceKey/list'
    | '/$workspaceSlug/projects/$projectKey/views/'
    | '/$workspaceSlug/spaces/$spaceKey/views/'
    | '/$workspaceSlug/projects/$projectKey/cycles/$cycleId'
    | '/$workspaceSlug/projects/$projectKey/pages/$pageSlug'
    | '/$workspaceSlug/projects/$projectKey/views/$viewId'
    | '/$workspaceSlug/spaces/$spaceKey/pages/$pageSlug'
    | '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey'
    | '/$workspaceSlug/spaces/$spaceKey/views/$viewId'
    | '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/settings'
    | '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/views/'
    | '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/cycles/$cycleId'
    | '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/pages/$pageSlug'
    | '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/views/$viewId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/workspaces'
    | '/auth'
    | '/callback'
    | '/logout'
    | '/onboarding'
    | '/invite/accept'
    | '/oauth/consent'
    | '/oauth/login'
    | '/$workspaceSlug'
    | '/$workspaceSlug/notes'
    | '/$workspaceSlug/notifications'
    | '/$workspaceSlug/settings'
    | '/$workspaceSlug/tags'
    | '/$workspaceSlug/tasks'
    | '/$workspaceSlug/_internal/build'
    | '/$workspaceSlug/projects/$projectKey'
    | '/$workspaceSlug/settings/ai'
    | '/$workspaceSlug/settings/ai-dev'
    | '/$workspaceSlug/settings/custom-fields'
    | '/$workspaceSlug/settings/database'
    | '/$workspaceSlug/settings/dev-subscription'
    | '/$workspaceSlug/settings/integrations'
    | '/$workspaceSlug/settings/labels'
    | '/$workspaceSlug/settings/members'
    | '/$workspaceSlug/settings/notifications'
    | '/$workspaceSlug/settings/preferences'
    | '/$workspaceSlug/settings/statuses'
    | '/$workspaceSlug/settings/subscription'
    | '/$workspaceSlug/settings/templates'
    | '/$workspaceSlug/settings/work-item-types'
    | '/$workspaceSlug/settings/workspace'
    | '/$workspaceSlug/spaces/$spaceKey'
    | '/$workspaceSlug/tags/$tagId'
    | '/$workspaceSlug/tasks/$taskId'
    | '/$workspaceSlug/tasks/someday'
    | '/$workspaceSlug/tasks/today'
    | '/$workspaceSlug/tasks/upcoming'
    | '/$workspaceSlug/notes/daily/$noteDate'
    | '/$workspaceSlug/notes/weekly/$noteDate'
    | '/$workspaceSlug/projects/$projectKey/settings'
    | '/$workspaceSlug/spaces/$spaceKey/board'
    | '/$workspaceSlug/spaces/$spaceKey/calendar'
    | '/$workspaceSlug/spaces/$spaceKey/gantt'
    | '/$workspaceSlug/spaces/$spaceKey/list'
    | '/$workspaceSlug/projects/$projectKey/views'
    | '/$workspaceSlug/spaces/$spaceKey/views'
    | '/$workspaceSlug/projects/$projectKey/cycles/$cycleId'
    | '/$workspaceSlug/projects/$projectKey/pages/$pageSlug'
    | '/$workspaceSlug/projects/$projectKey/views/$viewId'
    | '/$workspaceSlug/spaces/$spaceKey/pages/$pageSlug'
    | '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey'
    | '/$workspaceSlug/spaces/$spaceKey/views/$viewId'
    | '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/settings'
    | '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/views'
    | '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/cycles/$cycleId'
    | '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/pages/$pageSlug'
    | '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/views/$viewId'
  id:
    | '__root__'
    | '/'
    | '/_AppWrapper'
    | '/_AuthLayout'
    | '/_AppWrapper/_AppLayout'
    | '/_AppWrapper/workspaces'
    | '/_AuthLayout/auth'
    | '/_AuthLayout/callback'
    | '/_AuthLayout/logout'
    | '/_AuthLayout/onboarding'
    | '/_AuthLayout/invite/accept'
    | '/_AuthLayout/oauth/consent'
    | '/_AuthLayout/oauth/login'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/notes/'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/notifications/'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/settings/'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/tags/'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/tasks/'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/_internal/build'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/projects/$projectKey'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/settings/ai'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/settings/ai-dev'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/settings/custom-fields'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/settings/database'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/settings/dev-subscription'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/settings/integrations'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/settings/labels'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/settings/members'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/settings/notifications'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/settings/preferences'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/settings/statuses'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/settings/subscription'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/settings/templates'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/settings/work-item-types'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/settings/workspace'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/tags/$tagId'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/tasks/$taskId'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/tasks/someday'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/tasks/today'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/tasks/upcoming'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/notes/daily/$noteDate'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/notes/weekly/$noteDate'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/projects/$projectKey/settings'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/board'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/calendar'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/gantt'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/list'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/projects/$projectKey/views/'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/views/'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/projects/$projectKey/cycles/$cycleId'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/projects/$projectKey/pages/$pageSlug'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/projects/$projectKey/views/$viewId'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/pages/$pageSlug'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/projects/$projectKey'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/views/$viewId'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/settings'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/views/'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/cycles/$cycleId'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/pages/$pageSlug'
    | '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/views/$viewId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  indexRoute: typeof indexRoute
  AppWrapperRoute: typeof AppWrapperRouteWithChildren
  layoutAuthLayoutAuthLayoutRoute: typeof layoutAuthLayoutAuthLayoutRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof indexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_AppWrapper': {
      id: '/_AppWrapper'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppWrapperRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_AuthLayout': {
      id: '/_AuthLayout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof layoutAuthLayoutAuthLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_AppWrapper/_AppLayout': {
      id: '/_AppWrapper/_AppLayout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof layoutAppLayoutAppLayoutRouteImport
      parentRoute: typeof AppWrapperRoute
    }
    '/_AppWrapper/workspaces': {
      id: '/_AppWrapper/workspaces'
      path: '/workspaces'
      fullPath: '/workspaces'
      preLoaderRoute: typeof featuresWorkspacesPagesWorkspaceSelectionPageRouteImport
      parentRoute: typeof AppWrapperRoute
    }
    '/_AuthLayout/auth': {
      id: '/_AuthLayout/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof featuresAuthenticationPagesAuthGatewayPageRouteImport
      parentRoute: typeof layoutAuthLayoutAuthLayoutRoute
    }
    '/_AuthLayout/callback': {
      id: '/_AuthLayout/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof featuresAuthenticationPagesCallbackPageRouteImport
      parentRoute: typeof layoutAuthLayoutAuthLayoutRoute
    }
    '/_AuthLayout/logout': {
      id: '/_AuthLayout/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof featuresAuthenticationPagesLogoutPageRouteImport
      parentRoute: typeof layoutAuthLayoutAuthLayoutRoute
    }
    '/_AuthLayout/onboarding': {
      id: '/_AuthLayout/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof featuresAuthenticationPagesOnboardingPageRouteImport
      parentRoute: typeof layoutAuthLayoutAuthLayoutRoute
    }
    '/_AuthLayout/invite/accept': {
      id: '/_AuthLayout/invite/accept'
      path: '/invite/accept'
      fullPath: '/invite/accept'
      preLoaderRoute: typeof featuresInvitesPagesInviteAcceptancePageRouteImport
      parentRoute: typeof layoutAuthLayoutAuthLayoutRoute
    }
    '/_AuthLayout/oauth/consent': {
      id: '/_AuthLayout/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof featuresOauthPagesOAuthConsentPageRouteImport
      parentRoute: typeof layoutAuthLayoutAuthLayoutRoute
    }
    '/_AuthLayout/oauth/login': {
      id: '/_AuthLayout/oauth/login'
      path: '/oauth/login'
      fullPath: '/oauth/login'
      preLoaderRoute: typeof featuresOauthPagesOAuthLoginPageRouteImport
      parentRoute: typeof layoutAuthLayoutAuthLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/'
      path: '/$workspaceSlug'
      fullPath: '/$workspaceSlug/'
      preLoaderRoute: typeof featuresDashboardPagesDashboardPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/_internal/build': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/_internal/build'
      path: '/$workspaceSlug/_internal/build'
      fullPath: '/$workspaceSlug/_internal/build'
      preLoaderRoute: typeof featuresSettingsAboutPagesAboutSettingsPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/notes/': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/notes/'
      path: '/$workspaceSlug/notes'
      fullPath: '/$workspaceSlug/notes/'
      preLoaderRoute: typeof featuresNotesPagesNotesRedirectPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/notifications/': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/notifications/'
      path: '/$workspaceSlug/notifications'
      fullPath: '/$workspaceSlug/notifications/'
      preLoaderRoute: typeof featuresNotificationsPagesNotificationListPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/projects/$projectKey': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/projects/$projectKey'
      path: '/$workspaceSlug/projects/$projectKey'
      fullPath: '/$workspaceSlug/projects/$projectKey'
      preLoaderRoute: typeof featuresProjectsPagesProjectLayoutRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/settings/': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/settings/'
      path: '/$workspaceSlug/settings'
      fullPath: '/$workspaceSlug/settings/'
      preLoaderRoute: typeof featuresSettingsProfilePagesProfileSettingsPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/settings/ai': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/settings/ai'
      path: '/$workspaceSlug/settings/ai'
      fullPath: '/$workspaceSlug/settings/ai'
      preLoaderRoute: typeof featuresSettingsAiPagesAiSettingsPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/settings/ai-dev': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/settings/ai-dev'
      path: '/$workspaceSlug/settings/ai-dev'
      fullPath: '/$workspaceSlug/settings/ai-dev'
      preLoaderRoute: typeof featuresAiPagesAiDevPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/settings/custom-fields': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/settings/custom-fields'
      path: '/$workspaceSlug/settings/custom-fields'
      fullPath: '/$workspaceSlug/settings/custom-fields'
      preLoaderRoute: typeof featuresSettingsCustomFieldsPagesCustomFieldSettingsPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/settings/database': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/settings/database'
      path: '/$workspaceSlug/settings/database'
      fullPath: '/$workspaceSlug/settings/database'
      preLoaderRoute: typeof featuresSettingsDatabasePagesDatabaseSettingsPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/settings/dev-subscription': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/settings/dev-subscription'
      path: '/$workspaceSlug/settings/dev-subscription'
      fullPath: '/$workspaceSlug/settings/dev-subscription'
      preLoaderRoute: typeof featuresSettingsSubscriptionPagesDevSubscriptionTestingPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/settings/integrations': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/settings/integrations'
      path: '/$workspaceSlug/settings/integrations'
      fullPath: '/$workspaceSlug/settings/integrations'
      preLoaderRoute: typeof featuresSettingsIntegrationsPagesIntegrationsSettingsPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/settings/labels': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/settings/labels'
      path: '/$workspaceSlug/settings/labels'
      fullPath: '/$workspaceSlug/settings/labels'
      preLoaderRoute: typeof featuresSettingsLabelsPagesLabelSettingsPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/settings/members': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/settings/members'
      path: '/$workspaceSlug/settings/members'
      fullPath: '/$workspaceSlug/settings/members'
      preLoaderRoute: typeof featuresSettingsMembersPagesMemberSettingsPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/settings/notifications': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/settings/notifications'
      path: '/$workspaceSlug/settings/notifications'
      fullPath: '/$workspaceSlug/settings/notifications'
      preLoaderRoute: typeof featuresSettingsNotificationsPagesNotificationSettingsPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/settings/preferences': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/settings/preferences'
      path: '/$workspaceSlug/settings/preferences'
      fullPath: '/$workspaceSlug/settings/preferences'
      preLoaderRoute: typeof featuresSettingsPreferencesPagesPreferencesSettingsPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/settings/statuses': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/settings/statuses'
      path: '/$workspaceSlug/settings/statuses'
      fullPath: '/$workspaceSlug/settings/statuses'
      preLoaderRoute: typeof featuresSettingsStatusPagesStatusSettingsPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/settings/subscription': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/settings/subscription'
      path: '/$workspaceSlug/settings/subscription'
      fullPath: '/$workspaceSlug/settings/subscription'
      preLoaderRoute: typeof featuresSettingsSubscriptionPagesSubscriptionSettingsPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/settings/templates': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/settings/templates'
      path: '/$workspaceSlug/settings/templates'
      fullPath: '/$workspaceSlug/settings/templates'
      preLoaderRoute: typeof featuresSettingsTemplatesPagesTemplateManagementPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/settings/work-item-types': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/settings/work-item-types'
      path: '/$workspaceSlug/settings/work-item-types'
      fullPath: '/$workspaceSlug/settings/work-item-types'
      preLoaderRoute: typeof featuresSettingsWorkItemTypesPagesWorkItemTypeSettingsPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/settings/workspace': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/settings/workspace'
      path: '/$workspaceSlug/settings/workspace'
      fullPath: '/$workspaceSlug/settings/workspace'
      preLoaderRoute: typeof featuresSettingsWorkspacePagesWorkspaceSettingsPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey'
      path: '/$workspaceSlug/spaces/$spaceKey'
      fullPath: '/$workspaceSlug/spaces/$spaceKey'
      preLoaderRoute: typeof featuresSpacesPagesSpaceDetailsPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/tags/': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/tags/'
      path: '/$workspaceSlug/tags'
      fullPath: '/$workspaceSlug/tags/'
      preLoaderRoute: typeof featuresTagsPagesTagListPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/tags/$tagId': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/tags/$tagId'
      path: '/$workspaceSlug/tags/$tagId'
      fullPath: '/$workspaceSlug/tags/$tagId'
      preLoaderRoute: typeof featuresTagsPagesTagTasksPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/tasks/': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/tasks/'
      path: '/$workspaceSlug/tasks'
      fullPath: '/$workspaceSlug/tasks/'
      preLoaderRoute: typeof featuresTasksPagesTaskListPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/tasks/$taskId': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/tasks/$taskId'
      path: '/$workspaceSlug/tasks/$taskId'
      fullPath: '/$workspaceSlug/tasks/$taskId'
      preLoaderRoute: typeof featuresTasksPagesTaskDetailsPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/tasks/someday': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/tasks/someday'
      path: '/$workspaceSlug/tasks/someday'
      fullPath: '/$workspaceSlug/tasks/someday'
      preLoaderRoute: typeof featuresTasksPagesSomedayPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/tasks/today': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/tasks/today'
      path: '/$workspaceSlug/tasks/today'
      fullPath: '/$workspaceSlug/tasks/today'
      preLoaderRoute: typeof featuresTasksPagesTodayPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/tasks/upcoming': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/tasks/upcoming'
      path: '/$workspaceSlug/tasks/upcoming'
      fullPath: '/$workspaceSlug/tasks/upcoming'
      preLoaderRoute: typeof featuresTasksPagesUpcomingPageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/notes/daily/$noteDate': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/notes/daily/$noteDate'
      path: '/$workspaceSlug/notes/daily/$noteDate'
      fullPath: '/$workspaceSlug/notes/daily/$noteDate'
      preLoaderRoute: typeof featuresNotesPagesDailyNotePageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/notes/weekly/$noteDate': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/notes/weekly/$noteDate'
      path: '/$workspaceSlug/notes/weekly/$noteDate'
      fullPath: '/$workspaceSlug/notes/weekly/$noteDate'
      preLoaderRoute: typeof featuresNotesPagesWeeklyNotePageRouteImport
      parentRoute: typeof layoutAppLayoutAppLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/projects/$projectKey/settings': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/projects/$projectKey/settings'
      path: '/settings'
      fullPath: '/$workspaceSlug/projects/$projectKey/settings'
      preLoaderRoute: typeof featuresProjectsPagesProjectSettingsPageRouteImport
      parentRoute: typeof featuresProjectsPagesProjectLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/board': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/board'
      path: '/board'
      fullPath: '/$workspaceSlug/spaces/$spaceKey/board'
      preLoaderRoute: typeof featuresSpacesPagesSpaceBoardViewPageRouteImport
      parentRoute: typeof featuresSpacesPagesSpaceDetailsPageRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/calendar': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/calendar'
      path: '/calendar'
      fullPath: '/$workspaceSlug/spaces/$spaceKey/calendar'
      preLoaderRoute: typeof featuresSpacesPagesSpaceCalendarViewPageRouteImport
      parentRoute: typeof featuresSpacesPagesSpaceDetailsPageRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/gantt': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/gantt'
      path: '/gantt'
      fullPath: '/$workspaceSlug/spaces/$spaceKey/gantt'
      preLoaderRoute: typeof featuresSpacesPagesSpaceGanttViewPageRouteImport
      parentRoute: typeof featuresSpacesPagesSpaceDetailsPageRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/list': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/list'
      path: '/list'
      fullPath: '/$workspaceSlug/spaces/$spaceKey/list'
      preLoaderRoute: typeof featuresSpacesPagesSpaceListViewPageRouteImport
      parentRoute: typeof featuresSpacesPagesSpaceDetailsPageRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/projects/$projectKey/cycles/$cycleId': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/projects/$projectKey/cycles/$cycleId'
      path: '/cycles/$cycleId'
      fullPath: '/$workspaceSlug/projects/$projectKey/cycles/$cycleId'
      preLoaderRoute: typeof featuresProjectsPagesCycleDetailsPageRouteImport
      parentRoute: typeof featuresProjectsPagesProjectLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/projects/$projectKey/pages/$pageSlug': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/projects/$projectKey/pages/$pageSlug'
      path: '/pages/$pageSlug'
      fullPath: '/$workspaceSlug/projects/$projectKey/pages/$pageSlug'
      preLoaderRoute: typeof featuresPagesPagesPageDetailsPageRouteImport
      parentRoute: typeof featuresProjectsPagesProjectLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/projects/$projectKey/views/': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/projects/$projectKey/views/'
      path: '/views'
      fullPath: '/$workspaceSlug/projects/$projectKey/views/'
      preLoaderRoute: typeof featuresProjectsPagesProjectViewsIndexPageRouteImport
      parentRoute: typeof featuresProjectsPagesProjectLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/projects/$projectKey/views/$viewId': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/projects/$projectKey/views/$viewId'
      path: '/views/$viewId'
      fullPath: '/$workspaceSlug/projects/$projectKey/views/$viewId'
      preLoaderRoute: typeof featuresProjectsPagesProjectViewPageRouteImport
      parentRoute: typeof featuresProjectsPagesProjectLayoutRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/pages/$pageSlug': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/pages/$pageSlug'
      path: '/pages/$pageSlug'
      fullPath: '/$workspaceSlug/spaces/$spaceKey/pages/$pageSlug'
      preLoaderRoute: typeof featuresSpacesPagesSpacePageDetailsPageRouteImport
      parentRoute: typeof featuresSpacesPagesSpaceDetailsPageRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/projects/$projectKey': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/projects/$projectKey'
      path: '/projects/$projectKey'
      fullPath: '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey'
      preLoaderRoute: typeof featuresSpacesPagesSpaceProjectDetailsPageRouteImport
      parentRoute: typeof featuresSpacesPagesSpaceDetailsPageRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/views/': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/views/'
      path: '/views'
      fullPath: '/$workspaceSlug/spaces/$spaceKey/views/'
      preLoaderRoute: typeof featuresSpacesPagesSpaceViewsIndexPageRouteImport
      parentRoute: typeof featuresSpacesPagesSpaceDetailsPageRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/views/$viewId': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/views/$viewId'
      path: '/views/$viewId'
      fullPath: '/$workspaceSlug/spaces/$spaceKey/views/$viewId'
      preLoaderRoute: typeof featuresSpacesPagesSpaceViewPageRouteImport
      parentRoute: typeof featuresSpacesPagesSpaceDetailsPageRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/settings': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/settings'
      path: '/settings'
      fullPath: '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/settings'
      preLoaderRoute: typeof featuresSpacesPagesSpaceProjectSettingsPageRouteImport
      parentRoute: typeof featuresSpacesPagesSpaceProjectDetailsPageRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/cycles/$cycleId': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/cycles/$cycleId'
      path: '/cycles/$cycleId'
      fullPath: '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/cycles/$cycleId'
      preLoaderRoute: typeof featuresSpacesPagesSpaceCycleDetailsPageRouteImport
      parentRoute: typeof featuresSpacesPagesSpaceProjectDetailsPageRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/pages/$pageSlug': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/pages/$pageSlug'
      path: '/pages/$pageSlug'
      fullPath: '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/pages/$pageSlug'
      preLoaderRoute: typeof featuresSpacesPagesSpaceProjectPageDetailsPageRouteImport
      parentRoute: typeof featuresSpacesPagesSpaceProjectDetailsPageRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/views/': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/views/'
      path: '/views'
      fullPath: '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/views/'
      preLoaderRoute: typeof featuresSpacesPagesSpaceProjectViewsIndexPageRouteImport
      parentRoute: typeof featuresSpacesPagesSpaceProjectDetailsPageRoute
    }
    '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/views/$viewId': {
      id: '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/views/$viewId'
      path: '/views/$viewId'
      fullPath: '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/views/$viewId'
      preLoaderRoute: typeof featuresSpacesPagesSpaceProjectViewPageRouteImport
      parentRoute: typeof featuresSpacesPagesSpaceProjectDetailsPageRoute
    }
  }
}

interface featuresProjectsPagesProjectLayoutRouteChildren {
  featuresProjectsPagesProjectSettingsPageRoute: typeof featuresProjectsPagesProjectSettingsPageRoute
  featuresProjectsPagesProjectViewsIndexPageRoute: typeof featuresProjectsPagesProjectViewsIndexPageRoute
  featuresProjectsPagesCycleDetailsPageRoute: typeof featuresProjectsPagesCycleDetailsPageRoute
  featuresPagesPagesPageDetailsPageRoute: typeof featuresPagesPagesPageDetailsPageRoute
  featuresProjectsPagesProjectViewPageRoute: typeof featuresProjectsPagesProjectViewPageRoute
}

const featuresProjectsPagesProjectLayoutRouteChildren: featuresProjectsPagesProjectLayoutRouteChildren =
  {
    featuresProjectsPagesProjectSettingsPageRoute:
      featuresProjectsPagesProjectSettingsPageRoute,
    featuresProjectsPagesProjectViewsIndexPageRoute:
      featuresProjectsPagesProjectViewsIndexPageRoute,
    featuresProjectsPagesCycleDetailsPageRoute:
      featuresProjectsPagesCycleDetailsPageRoute,
    featuresPagesPagesPageDetailsPageRoute:
      featuresPagesPagesPageDetailsPageRoute,
    featuresProjectsPagesProjectViewPageRoute:
      featuresProjectsPagesProjectViewPageRoute,
  }

const featuresProjectsPagesProjectLayoutRouteWithChildren =
  featuresProjectsPagesProjectLayoutRoute._addFileChildren(
    featuresProjectsPagesProjectLayoutRouteChildren,
  )

interface featuresSpacesPagesSpaceProjectDetailsPageRouteChildren {
  featuresSpacesPagesSpaceProjectSettingsPageRoute: typeof featuresSpacesPagesSpaceProjectSettingsPageRoute
  featuresSpacesPagesSpaceProjectViewsIndexPageRoute: typeof featuresSpacesPagesSpaceProjectViewsIndexPageRoute
  featuresSpacesPagesSpaceCycleDetailsPageRoute: typeof featuresSpacesPagesSpaceCycleDetailsPageRoute
  featuresSpacesPagesSpaceProjectPageDetailsPageRoute: typeof featuresSpacesPagesSpaceProjectPageDetailsPageRoute
  featuresSpacesPagesSpaceProjectViewPageRoute: typeof featuresSpacesPagesSpaceProjectViewPageRoute
}

const featuresSpacesPagesSpaceProjectDetailsPageRouteChildren: featuresSpacesPagesSpaceProjectDetailsPageRouteChildren =
  {
    featuresSpacesPagesSpaceProjectSettingsPageRoute:
      featuresSpacesPagesSpaceProjectSettingsPageRoute,
    featuresSpacesPagesSpaceProjectViewsIndexPageRoute:
      featuresSpacesPagesSpaceProjectViewsIndexPageRoute,
    featuresSpacesPagesSpaceCycleDetailsPageRoute:
      featuresSpacesPagesSpaceCycleDetailsPageRoute,
    featuresSpacesPagesSpaceProjectPageDetailsPageRoute:
      featuresSpacesPagesSpaceProjectPageDetailsPageRoute,
    featuresSpacesPagesSpaceProjectViewPageRoute:
      featuresSpacesPagesSpaceProjectViewPageRoute,
  }

const featuresSpacesPagesSpaceProjectDetailsPageRouteWithChildren =
  featuresSpacesPagesSpaceProjectDetailsPageRoute._addFileChildren(
    featuresSpacesPagesSpaceProjectDetailsPageRouteChildren,
  )

interface featuresSpacesPagesSpaceDetailsPageRouteChildren {
  featuresSpacesPagesSpaceBoardViewPageRoute: typeof featuresSpacesPagesSpaceBoardViewPageRoute
  featuresSpacesPagesSpaceCalendarViewPageRoute: typeof featuresSpacesPagesSpaceCalendarViewPageRoute
  featuresSpacesPagesSpaceGanttViewPageRoute: typeof featuresSpacesPagesSpaceGanttViewPageRoute
  featuresSpacesPagesSpaceListViewPageRoute: typeof featuresSpacesPagesSpaceListViewPageRoute
  featuresSpacesPagesSpaceViewsIndexPageRoute: typeof featuresSpacesPagesSpaceViewsIndexPageRoute
  featuresSpacesPagesSpacePageDetailsPageRoute: typeof featuresSpacesPagesSpacePageDetailsPageRoute
  featuresSpacesPagesSpaceProjectDetailsPageRoute: typeof featuresSpacesPagesSpaceProjectDetailsPageRouteWithChildren
  featuresSpacesPagesSpaceViewPageRoute: typeof featuresSpacesPagesSpaceViewPageRoute
}

const featuresSpacesPagesSpaceDetailsPageRouteChildren: featuresSpacesPagesSpaceDetailsPageRouteChildren =
  {
    featuresSpacesPagesSpaceBoardViewPageRoute:
      featuresSpacesPagesSpaceBoardViewPageRoute,
    featuresSpacesPagesSpaceCalendarViewPageRoute:
      featuresSpacesPagesSpaceCalendarViewPageRoute,
    featuresSpacesPagesSpaceGanttViewPageRoute:
      featuresSpacesPagesSpaceGanttViewPageRoute,
    featuresSpacesPagesSpaceListViewPageRoute:
      featuresSpacesPagesSpaceListViewPageRoute,
    featuresSpacesPagesSpaceViewsIndexPageRoute:
      featuresSpacesPagesSpaceViewsIndexPageRoute,
    featuresSpacesPagesSpacePageDetailsPageRoute:
      featuresSpacesPagesSpacePageDetailsPageRoute,
    featuresSpacesPagesSpaceProjectDetailsPageRoute:
      featuresSpacesPagesSpaceProjectDetailsPageRouteWithChildren,
    featuresSpacesPagesSpaceViewPageRoute:
      featuresSpacesPagesSpaceViewPageRoute,
  }

const featuresSpacesPagesSpaceDetailsPageRouteWithChildren =
  featuresSpacesPagesSpaceDetailsPageRoute._addFileChildren(
    featuresSpacesPagesSpaceDetailsPageRouteChildren,
  )

interface layoutAppLayoutAppLayoutRouteChildren {
  featuresDashboardPagesDashboardPageRoute: typeof featuresDashboardPagesDashboardPageRoute
  featuresNotesPagesNotesRedirectPageRoute: typeof featuresNotesPagesNotesRedirectPageRoute
  featuresNotificationsPagesNotificationListPageRoute: typeof featuresNotificationsPagesNotificationListPageRoute
  featuresSettingsProfilePagesProfileSettingsPageRoute: typeof featuresSettingsProfilePagesProfileSettingsPageRoute
  featuresTagsPagesTagListPageRoute: typeof featuresTagsPagesTagListPageRoute
  featuresTasksPagesTaskListPageRoute: typeof featuresTasksPagesTaskListPageRoute
  featuresSettingsAboutPagesAboutSettingsPageRoute: typeof featuresSettingsAboutPagesAboutSettingsPageRoute
  featuresProjectsPagesProjectLayoutRoute: typeof featuresProjectsPagesProjectLayoutRouteWithChildren
  featuresSettingsAiPagesAiSettingsPageRoute: typeof featuresSettingsAiPagesAiSettingsPageRoute
  featuresAiPagesAiDevPageRoute: typeof featuresAiPagesAiDevPageRoute
  featuresSettingsCustomFieldsPagesCustomFieldSettingsPageRoute: typeof featuresSettingsCustomFieldsPagesCustomFieldSettingsPageRoute
  featuresSettingsDatabasePagesDatabaseSettingsPageRoute: typeof featuresSettingsDatabasePagesDatabaseSettingsPageRoute
  featuresSettingsSubscriptionPagesDevSubscriptionTestingPageRoute: typeof featuresSettingsSubscriptionPagesDevSubscriptionTestingPageRoute
  featuresSettingsIntegrationsPagesIntegrationsSettingsPageRoute: typeof featuresSettingsIntegrationsPagesIntegrationsSettingsPageRoute
  featuresSettingsLabelsPagesLabelSettingsPageRoute: typeof featuresSettingsLabelsPagesLabelSettingsPageRoute
  featuresSettingsMembersPagesMemberSettingsPageRoute: typeof featuresSettingsMembersPagesMemberSettingsPageRoute
  featuresSettingsNotificationsPagesNotificationSettingsPageRoute: typeof featuresSettingsNotificationsPagesNotificationSettingsPageRoute
  featuresSettingsPreferencesPagesPreferencesSettingsPageRoute: typeof featuresSettingsPreferencesPagesPreferencesSettingsPageRoute
  featuresSettingsStatusPagesStatusSettingsPageRoute: typeof featuresSettingsStatusPagesStatusSettingsPageRoute
  featuresSettingsSubscriptionPagesSubscriptionSettingsPageRoute: typeof featuresSettingsSubscriptionPagesSubscriptionSettingsPageRoute
  featuresSettingsTemplatesPagesTemplateManagementPageRoute: typeof featuresSettingsTemplatesPagesTemplateManagementPageRoute
  featuresSettingsWorkItemTypesPagesWorkItemTypeSettingsPageRoute: typeof featuresSettingsWorkItemTypesPagesWorkItemTypeSettingsPageRoute
  featuresSettingsWorkspacePagesWorkspaceSettingsPageRoute: typeof featuresSettingsWorkspacePagesWorkspaceSettingsPageRoute
  featuresSpacesPagesSpaceDetailsPageRoute: typeof featuresSpacesPagesSpaceDetailsPageRouteWithChildren
  featuresTagsPagesTagTasksPageRoute: typeof featuresTagsPagesTagTasksPageRoute
  featuresTasksPagesTaskDetailsPageRoute: typeof featuresTasksPagesTaskDetailsPageRoute
  featuresTasksPagesSomedayPageRoute: typeof featuresTasksPagesSomedayPageRoute
  featuresTasksPagesTodayPageRoute: typeof featuresTasksPagesTodayPageRoute
  featuresTasksPagesUpcomingPageRoute: typeof featuresTasksPagesUpcomingPageRoute
  featuresNotesPagesDailyNotePageRoute: typeof featuresNotesPagesDailyNotePageRoute
  featuresNotesPagesWeeklyNotePageRoute: typeof featuresNotesPagesWeeklyNotePageRoute
}

const layoutAppLayoutAppLayoutRouteChildren: layoutAppLayoutAppLayoutRouteChildren =
  {
    featuresDashboardPagesDashboardPageRoute:
      featuresDashboardPagesDashboardPageRoute,
    featuresNotesPagesNotesRedirectPageRoute:
      featuresNotesPagesNotesRedirectPageRoute,
    featuresNotificationsPagesNotificationListPageRoute:
      featuresNotificationsPagesNotificationListPageRoute,
    featuresSettingsProfilePagesProfileSettingsPageRoute:
      featuresSettingsProfilePagesProfileSettingsPageRoute,
    featuresTagsPagesTagListPageRoute: featuresTagsPagesTagListPageRoute,
    featuresTasksPagesTaskListPageRoute: featuresTasksPagesTaskListPageRoute,
    featuresSettingsAboutPagesAboutSettingsPageRoute:
      featuresSettingsAboutPagesAboutSettingsPageRoute,
    featuresProjectsPagesProjectLayoutRoute:
      featuresProjectsPagesProjectLayoutRouteWithChildren,
    featuresSettingsAiPagesAiSettingsPageRoute:
      featuresSettingsAiPagesAiSettingsPageRoute,
    featuresAiPagesAiDevPageRoute: featuresAiPagesAiDevPageRoute,
    featuresSettingsCustomFieldsPagesCustomFieldSettingsPageRoute:
      featuresSettingsCustomFieldsPagesCustomFieldSettingsPageRoute,
    featuresSettingsDatabasePagesDatabaseSettingsPageRoute:
      featuresSettingsDatabasePagesDatabaseSettingsPageRoute,
    featuresSettingsSubscriptionPagesDevSubscriptionTestingPageRoute:
      featuresSettingsSubscriptionPagesDevSubscriptionTestingPageRoute,
    featuresSettingsIntegrationsPagesIntegrationsSettingsPageRoute:
      featuresSettingsIntegrationsPagesIntegrationsSettingsPageRoute,
    featuresSettingsLabelsPagesLabelSettingsPageRoute:
      featuresSettingsLabelsPagesLabelSettingsPageRoute,
    featuresSettingsMembersPagesMemberSettingsPageRoute:
      featuresSettingsMembersPagesMemberSettingsPageRoute,
    featuresSettingsNotificationsPagesNotificationSettingsPageRoute:
      featuresSettingsNotificationsPagesNotificationSettingsPageRoute,
    featuresSettingsPreferencesPagesPreferencesSettingsPageRoute:
      featuresSettingsPreferencesPagesPreferencesSettingsPageRoute,
    featuresSettingsStatusPagesStatusSettingsPageRoute:
      featuresSettingsStatusPagesStatusSettingsPageRoute,
    featuresSettingsSubscriptionPagesSubscriptionSettingsPageRoute:
      featuresSettingsSubscriptionPagesSubscriptionSettingsPageRoute,
    featuresSettingsTemplatesPagesTemplateManagementPageRoute:
      featuresSettingsTemplatesPagesTemplateManagementPageRoute,
    featuresSettingsWorkItemTypesPagesWorkItemTypeSettingsPageRoute:
      featuresSettingsWorkItemTypesPagesWorkItemTypeSettingsPageRoute,
    featuresSettingsWorkspacePagesWorkspaceSettingsPageRoute:
      featuresSettingsWorkspacePagesWorkspaceSettingsPageRoute,
    featuresSpacesPagesSpaceDetailsPageRoute:
      featuresSpacesPagesSpaceDetailsPageRouteWithChildren,
    featuresTagsPagesTagTasksPageRoute: featuresTagsPagesTagTasksPageRoute,
    featuresTasksPagesTaskDetailsPageRoute:
      featuresTasksPagesTaskDetailsPageRoute,
    featuresTasksPagesSomedayPageRoute: featuresTasksPagesSomedayPageRoute,
    featuresTasksPagesTodayPageRoute: featuresTasksPagesTodayPageRoute,
    featuresTasksPagesUpcomingPageRoute: featuresTasksPagesUpcomingPageRoute,
    featuresNotesPagesDailyNotePageRoute: featuresNotesPagesDailyNotePageRoute,
    featuresNotesPagesWeeklyNotePageRoute:
      featuresNotesPagesWeeklyNotePageRoute,
  }

const layoutAppLayoutAppLayoutRouteWithChildren =
  layoutAppLayoutAppLayoutRoute._addFileChildren(
    layoutAppLayoutAppLayoutRouteChildren,
  )

interface AppWrapperRouteChildren {
  layoutAppLayoutAppLayoutRoute: typeof layoutAppLayoutAppLayoutRouteWithChildren
  featuresWorkspacesPagesWorkspaceSelectionPageRoute: typeof featuresWorkspacesPagesWorkspaceSelectionPageRoute
}

const AppWrapperRouteChildren: AppWrapperRouteChildren = {
  layoutAppLayoutAppLayoutRoute: layoutAppLayoutAppLayoutRouteWithChildren,
  featuresWorkspacesPagesWorkspaceSelectionPageRoute:
    featuresWorkspacesPagesWorkspaceSelectionPageRoute,
}

const AppWrapperRouteWithChildren = AppWrapperRoute._addFileChildren(
  AppWrapperRouteChildren,
)

interface layoutAuthLayoutAuthLayoutRouteChildren {
  featuresAuthenticationPagesAuthGatewayPageRoute: typeof featuresAuthenticationPagesAuthGatewayPageRoute
  featuresAuthenticationPagesCallbackPageRoute: typeof featuresAuthenticationPagesCallbackPageRoute
  featuresAuthenticationPagesLogoutPageRoute: typeof featuresAuthenticationPagesLogoutPageRoute
  featuresAuthenticationPagesOnboardingPageRoute: typeof featuresAuthenticationPagesOnboardingPageRoute
  featuresInvitesPagesInviteAcceptancePageRoute: typeof featuresInvitesPagesInviteAcceptancePageRoute
  featuresOauthPagesOAuthConsentPageRoute: typeof featuresOauthPagesOAuthConsentPageRoute
  featuresOauthPagesOAuthLoginPageRoute: typeof featuresOauthPagesOAuthLoginPageRoute
}

const layoutAuthLayoutAuthLayoutRouteChildren: layoutAuthLayoutAuthLayoutRouteChildren =
  {
    featuresAuthenticationPagesAuthGatewayPageRoute:
      featuresAuthenticationPagesAuthGatewayPageRoute,
    featuresAuthenticationPagesCallbackPageRoute:
      featuresAuthenticationPagesCallbackPageRoute,
    featuresAuthenticationPagesLogoutPageRoute:
      featuresAuthenticationPagesLogoutPageRoute,
    featuresAuthenticationPagesOnboardingPageRoute:
      featuresAuthenticationPagesOnboardingPageRoute,
    featuresInvitesPagesInviteAcceptancePageRoute:
      featuresInvitesPagesInviteAcceptancePageRoute,
    featuresOauthPagesOAuthConsentPageRoute:
      featuresOauthPagesOAuthConsentPageRoute,
    featuresOauthPagesOAuthLoginPageRoute:
      featuresOauthPagesOAuthLoginPageRoute,
  }

const layoutAuthLayoutAuthLayoutRouteWithChildren =
  layoutAuthLayoutAuthLayoutRoute._addFileChildren(
    layoutAuthLayoutAuthLayoutRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  indexRoute: indexRoute,
  AppWrapperRoute: AppWrapperRouteWithChildren,
  layoutAuthLayoutAuthLayoutRoute: layoutAuthLayoutAuthLayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
